import { rounded } from '~/basket/model/utils/price'
import { getCountryCodeByCurrentDomain } from '~/util/domain/getCountryCodeByCurrentDomain'

export type Price = {
  withTax: number
  withoutTax: number
}

export const emptyPrice = {
  withTax: 0,
  withoutTax: 0,
}

export const toPrice = (price: Price | null): Price => price || emptyPrice

export const getCurrencyByDomain = () =>
  ({
    CH: 'CHF',
    SE: 'Kr',
  })[getCountryCodeByCurrentDomain()] || '€'

function formattedPrice(price: number): string {
  return rounded(price).toFixed(2)
}

export const formattedNumber = (price: number, emptyValue = '_.__'): string =>
  `${getCurrencyByDomain()} ${price === 0 ? emptyValue : formattedPrice(price)}`

export const formattedTotalPrice = (price: Price, emptyValue = '_.__'): string =>
  `${getCurrencyByDomain()} ${price.withTax === 0 ? emptyValue : formattedPrice(price.withTax)}`

export const formattedOptionPrice = (price: Price, noPrice = ''): string =>
  price.withTax === 0 ? noPrice : `${getCurrencyByDomain()} ${formattedPrice(price.withTax)}`

export const calculateVatAmount = (price: Price): number => price.withTax - price.withoutTax
